<template>
	<mt-picker 
		:showToolbar= true
		:slots="slots" 
		@change="onValuesChange"
		valueKey = 'value'
		>
			<span class="mint-datetime-cancel"  @click="cancel">取消</span><span class="mint-datetime-confirm" @click="submit">确定</span>

	</mt-picker>

</template>

<script>
import api from '@/api/api.js';
import { mapState,mapGetters } from 'vuex'
export default {
	props: ['isOrderAddress','isAdd'],
	data(){
		return {
			slots: [
			        {
			          flex: 1,
			          values: [],
			          className: 'slot1',
			          textAlign: 'right'
			        }, {
			          divider: true,
			          content: '-',
			          className: 'slot2'
			        }, {
			          flex: 1,
			          values: [],
			          className: 'slot3',
			          textAlign: 'left'
			        }
			        , {
			          divider: true,
			          content: '-',
			          className: 'slot4'
			        }, {
			          flex: 1,
			          values: [],
			          className: 'slot5',
			          textAlign: 'left'
			        }
			    ],
		    curPro:'',
		    curCity: '',
		    regionalismId:'',
		    pickerArea:'',
		}
	},
	computed: {
      ...mapState({
        provinceList: state=>state.addressSelect.provinceList,
        cityList: state=>state.addressSelect.cityList,
        regionList: state=>state.addressSelect.regionList,
      }),
    },
	watch:{
		curPro(val,oldValue){
			let self = this;
			console.log('curPro',oldValue);
			if(self.isOrderAddress == true) return false;
			this.$nextTick(function(){
				val&&self.$store.dispatch('getOriginCity',{'provinceId':val})
			})
		},
		curCity(val,oldValue){
			let self = this;
			console.log(oldValue);
			this.$nextTick(function(){
				const { isOrderAddress } = self;
				if( isOrderAddress) {
					//开通城市
					val&&self.$store.dispatch('getOpenRegional',{'cityId':val})
				}else {
					//全国
					val&&self.$store.dispatch('getOriginRegional',{'cityId':val})
				}
			})				
		},
		cityList(val,oldValue){
	        if(val !== oldValue){
	          this.slots[2].values = val;
	        }
	    },
      	provinceList(val,oldValue){
	        if(val !== oldValue){
	          this.slots[0].values = val;
	        }
	    },
		regionList(val,oldValue){
			if(val !== oldValue){
	          this.slots[4].values = val;
	        }
		},
	},
	methods:{
		onValuesChange(picker, values) {
	      	var self  = this;
	      	console.log(values);
			this.$nextTick(function(){
				self.curPro = values[0] ?  values[0].key : '';
				self.curCity = values[1] ?  values[1].key : '';
				self.regionalismId = values[2] ?  values[2].key : '';
				self.pickerArea = values[2] ? values.map(function(item){
					return item.value ? item.value : '';
				}):'';
			})
		},
		getProvince(){//省市
			let self = this;
			this.$store.dispatch('getOriginProvince')

		},
		cancel(){
			this.$emit('cancel');
		},
		submit(){
			let self = this;
			let area = {
				pickerArea: self.pickerArea,
				regionalismId: self.regionalismId
			}
			this.$emit('submit',area);
		}
	},
	mounted(){
			let self = this;
			const {  isOrderAddress } = this;
			if(isOrderAddress){
				let defaultCity =  {cityId:'440300', id:"440300", regionId: '440300',name:"深圳市", cityName:"深圳市", provinceName: "广东省"}
				let locationCity,rId,currCityObj;
				if(localStorage.locationCity){
					locationCity = JSON.parse(localStorage.locationCity);
					
				}else {
					locationCity = defaultCity;
				}

				rId = locationCity.regionId;
				let currProId =String(rId).substring(0,2)+'0000';
				let currCityId = String(rId).substring(0,4)+'00';

				self.slots[0].values = [{
					key: currProId,
					value: locationCity.provinceName
				}];
				self.slots[2].values = [{
					key: currCityId,
					value: locationCity.cityName
				}];

			}else {
				self.getProvince()
			}
	}

}
</script>


// WEBPACK FOOTER //
// addressPick.vue?eaf08cce